import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert, Button, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('loading'); // loading, success, error
    const [message, setMessage] = useState('');

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            setStatus('error');
            setMessage('Kein Verification-Token gefunden');
            return;
        }

        const verifyEmail = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/auth/verify-email`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ token })
                });

                const data = await response.json();
                if (data.success) {
                    setStatus('success');
                    setMessage(data.message);
                } else {
                    setStatus('error');
                    setMessage(data.message || 'Verifizierung fehlgeschlagen');
                }
            } catch (err) {
                setStatus('error');
                setMessage('Netzwerkfehler. Bitte versuche es später erneut.');
            }
        };

        verifyEmail();
    }, [searchParams]);

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%)',
            p: 2
        }}>
            <Paper sx={{
                maxWidth: 460,
                width: '100%',
                p: 4,
                borderRadius: "12px",
                textAlign: 'center',
                background: 'rgba(255,255,255,0.05)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.1)'
            }}>
                {status === 'loading' && (
                    <>
                        <CircularProgress size={60} sx={{ color: '#c6ff00', mb: 3 }} />
                        <Typography variant="h5" sx={{ color: '#fff', fontWeight: 600 }}>
                            E-Mail wird verifiziert...
                        </Typography>
                    </>
                )}

                {status === 'success' && (
                    <>
                        <CheckCircleOutlineIcon sx={{ fontSize: 80, color: '#c6ff00', mb: 2 }} />
                        <Typography variant="h5" sx={{ color: '#fff', fontWeight: 600, mb: 1 }}>
                            Erfolgreich!
                        </Typography>
                        <Alert severity="success" sx={{ mb: 3, borderRadius: "12px" }}>
                            {message}
                        </Alert>
                        <Button
                            variant="contained"
                            onClick={() => navigate('/auth')}
                            sx={{
                                background: '#c6ff00',
                                color: '#000',
                                fontWeight: 700,
                                '&:hover': { background: '#aeea00' }
                            }}
                        >
                            Zum Login
                        </Button>
                    </>
                )}

                {status === 'error' && (
                    <>
                        <ErrorOutlineIcon sx={{ fontSize: 80, color: '#ff5252', mb: 2 }} />
                        <Typography variant="h5" sx={{ color: '#fff', fontWeight: 600, mb: 1 }}>
                            Fehler
                        </Typography>
                        <Alert severity="error" sx={{ mb: 3, borderRadius: "12px" }}>
                            {message}
                        </Alert>
                        <Button
                            variant="outlined"
                            onClick={() => navigate('/auth')}
                            sx={{
                                borderColor: 'rgba(255,255,255,0.3)',
                                color: '#fff',
                                '&:hover': { borderColor: '#c6ff00', color: '#c6ff00' }
                            }}
                        >
                            Zurück zum Login
                        </Button>
                    </>
                )}
            </Paper>
        </Box>
    );
};

export default VerifyEmail;
